import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getExpenditureFile, moneyreset, profileupdatereset } from "../../redux/action/userActions";
import { getLocalStorage } from "../../utils/localStorage";
import { Funds } from "../Windows/Funds";
import { UpdateProfile } from "../Windows/UpdateProfile";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { Button } from "@material-ui/core";
import {  useSnackbar } from 'notistack';
import { useTitle } from "../../context/TitleProvider";

export const Profile = () => {
    const {setTitle} = useTitle()
    setTitle("Dashboard")
    const user = getLocalStorage("user");
    const [open, setOpen] = useState(false);
    const dispatch = useDispatch()
    const { enqueueSnackbar } = useSnackbar();
    const {fundstatus, 
        fundfailedMessage,
         profileupdate,
         updatefailedMessage,
         updatefailed
         } = useSelector(state => ({
        fundstatus: state.moneyState.status,
        fundfailedMessage: state.moneyState.failedMessage,
        profileupdate: state.userState.updated,
        updatefailedMessage: state.userState.updatefailedmessage,
        updatefailed: state.userState.updatefailed
    }))
   
    useEffect($=>{
        fundstatus==="completed" &&  enqueueSnackbar('Transaction Successful', { variant : 'success' });
        fundstatus==="failed" && enqueueSnackbar(fundfailedMessage, { variant : 'error' });
        return () => dispatch(moneyreset());
     }, [fundstatus, enqueueSnackbar, dispatch, fundfailedMessage])

     useEffect($=>{
        profileupdate && enqueueSnackbar('Profile update Successful', { variant : 'success' });
        updatefailed &&  enqueueSnackbar(updatefailedMessage,  { variant : 'error' });
        return () => dispatch(profileupdatereset());
     }, [profileupdate, updatefailed,updatefailedMessage , enqueueSnackbar, dispatch])
    
    const downloadCsvFile = $ =>{
         dispatch(getExpenditureFile(user))
         enqueueSnackbar('Downloaded', { variant : 'info' });
    }

    const hideData = (data, dataType )=>{
        let res;
        if(dataType  === "email"){
            data = data.split("@");
            return hideData(data[0], "string") + "@" + data[1]
        }
        else{
            data = data.toString().split("");
            res = new Array(data.length - 1).fill("*").map((el, i) => i <  (data.length/2) ? (el=data[i]) : (el="*")  );
            return res.join("") 
        }
    }
  
    return <>
       <div>
        <h1>Your profile</h1>
        <Table>
            <TableBody>
                     <TableRow>
                         <TableCell>
                             Available Funds
                         </TableCell>
                         <TableCell>
                         Rs  {(user.funds).toFixed(2)}
                         </TableCell>
                
                     </TableRow> 
                     <TableRow>
                         <TableCell>
                             Email
                         </TableCell>
                         <TableCell>
                         {hideData(user.email,"email")}
                         </TableCell>
                     </TableRow>  
                     <TableRow>
                         <TableCell>
                             Client Id
                         </TableCell>
                         <TableCell>
                              {user.clientId} 
                         </TableCell>
                     </TableRow>  
                     <TableRow>
                         <TableCell>
                               Pancard 
                         </TableCell>
                         <TableCell>
                         {hideData(user.pancard,"string")}
                             
                         </TableCell>
                     </TableRow> 
                     <TableRow>
                         <TableCell>
                              Mobile
                         </TableCell>
                         <TableCell>
                             {user.mobile}
                         
                         </TableCell>
                     </TableRow>   
                     <TableRow>
                         <TableCell>
                              Age 
                         </TableCell>
                         <TableCell>
                         {new Date().getFullYear() - user.yearBorn}
                         </TableCell>
                     </TableRow>    
                     <TableRow>
                         <TableCell>
                              Bank Number
                         </TableCell>
                         <TableCell>
                         {user.bankdetails === undefined && <p>Add bank</p>}
                         {user.bankdetails &&  hideData(user.bankdetails,"string")}
                         </TableCell>
                     </TableRow>               
            </TableBody>
        </Table>

       
    </div>
    {open === "updateProfile" && <UpdateProfile setOpen={setOpen}/>}
    {open === "funds" && <Funds setOpen={setOpen}/> }
    <br/>
    <Button  variant="contained"
color="default" onClick={downloadCsvFile}>Transactions report </Button>
      <br/><br/>
    <Button variant="contained"
color="primary" onClick={$=> setOpen("funds")}>Add/Withdraw Funds</Button>
     <br/><br/>
    <Button  variant="contained"
color="secondary" onClick={$ => setOpen("updateProfile")}>Update Profile</Button>
    </> 

}


